import { render, staticRenderFns } from "./LunchMenu.vue?vue&type=template&id=4d143dec"
import script from "./LunchMenu.vue?vue&type=script&lang=js"
export * from "./LunchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports